import React from "react"
import { VolumeToggle } from "./App"

import "./Splash.css"

function MessageIntroSI() {
	return (
		<>
			<p>&gt; Prejeli ste sporočilo v obliki generativnega kolaža.</p>
			<p>&gt; Besedilo in kolaž lahko po predvajanju spreminjate.</p>
			<p>&gt; Priporočamo ogled na računalniku.</p>
			<p>&gt; Vklopite zvočnike.</p>
		</>
	)
}

function IntructionsIntroSI() {
	return (
		<>
			<p>&gt; Vpišite besedilo za generiranje kolaža.</p>
			<p>&gt; Priporočamo ogled na računalniku.</p>
			<p>&gt; Vklopite zvočnike.</p>
		</>
	)
}

function MessageIntroEN() {
	return (
		<>
			<p>
				&gt; You have received a message in the form of a generative collage.
			</p>
			<p>
				&gt; After the message is plaid back, you can edit the collage yourself.
			</p>
			<p>&gt; We recommend viewing the page on your PC.</p>
			<p>&gt; Turn on the speakers.</p>
		</>
	)
}

function IntructionsIntroEN() {
	return (
		<>
			<p>&gt; Type text to generate a collage.</p>
			<p>&gt; We recommend viewing the page on your PC.</p>
			<p>&gt; Turn on the speakers.</p>
		</>
	)
}

export function Splash({
	hasMessage,
	onConfirm,
	isSoundAllowed,
	setSoundAllowed,
}) {
	return (
		<div className="Splash">
			<div className="text-content">
				<h1>
					HelloWorld.exe
					<br />
					--------------
				</h1>

				<div className="slovenian">
					<p>Dobrodošli v letu 3020, mnogo let po izumrtju človeštva.</p>
					{hasMessage ? <MessageIntroSI /> : <IntructionsIntroSI />}
				</div>

				<div className="english">
					<p>
						Welcome to the year 3020, many years after humankind had gone
						extinct.
					</p>
					{hasMessage ? <MessageIntroEN /> : <IntructionsIntroEN />}
				</div>

				<div className="entry">
					<VolumeToggle
						isActive={isSoundAllowed}
						onClick={() => setSoundAllowed(isSoundAllowed ? null : true)}
					/>
					<button onClick={onConfirm}>
						[<span className="slovenian">Vstopite</span>
						<span className="english">/ Enter</span>]
					</button>
				</div>
			</div>
		</div>
	)
}
